module.exports = __webpack_public_path__ + "img/usa-leukaemia-male.4c2775ff.png";